"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FireSale = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRequirements_1 = require("../../CardRequirements");
var Tags_1 = require("../../Tags");
var FireSale = (function (_super) {
    __extends(FireSale, _super);
    function FireSale() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.FIRE_SALE,
            tags: [Tags_1.Tags.EARTH],
            cost: 3,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(6).max(); }),
            metadata: {
                cardNumber: 'L301',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.text('-X').heat(1).nbsp.text('+').megacredits(0).multiplier;
                }),
                description: 'Convert all heat to M€.',
            },
        }) || this;
    }
    FireSale.prototype.play = function (player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, player.heat, { log: true });
        return player.spendHeat(player.heat);
    };
    return FireSale;
}(Card_1.Card));
exports.FireSale = FireSale;
//# sourceMappingURL=FireSale.js.map